import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Alert, Box, Chip, Divider, Typography } from '@mui/material';
import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
import { green, grey, orange } from '@mui/material/colors';
import moment from "moment";
import 'moment/locale/pt-br';

const METHOD_COLOR = {
  telefone: 'primary',
  whatsapp: 'success',
  email: 'warning',
  teams: 'info',
}

function AcksView({ data }) {
  return data.map((ack, i) => (
    <Alert key={i} sx={{ mt: 1, backgroundColor: grey[1000] }} severity="info">
      <Typography variant="body2">
        {ack.created_at ? moment(ack.created_at).locale('pt-br').format('DD-MM-YYYY HH:mm:ss') : ''}
      </Typography>
      {ack.description || ack.message}
    </Alert>
  ))
}

function ExecutionsView({ data }) {
  return data.map((exec, i) => (
    <Box key={i} sx={{ mt: 1, p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <Box>
          <Typography variant="subtitle2">{exec.ppi_description}</Typography>
          <Typography variant="caption" color="text.secondary">
            {exec.user_name} — {exec.created_at ? moment(exec.created_at).locale('pt-br').format('DD-MM-YYYY HH:mm:ss') : ''}
          </Typography>
        </Box>
        <Chip
          label={exec.completed ? 'Completo' : 'Parcial'}
          size="small"
          sx={{
            bgcolor: exec.completed ? green[600] : orange[600],
            color: '#fff',
            fontWeight: 600,
            fontSize: 11,
          }}
        />
      </Box>
      <Divider sx={{ mb: 1 }} />
      {Array.isArray(exec.steps_state) && exec.steps_state.map((step, j) => (
        <Box key={j} display="flex" alignItems="flex-start" gap={1} sx={{ py: 0.5 }}>
          {step.done
            ? <CheckCircle sx={{ color: green[500], fontSize: 20, mt: 0.2 }} />
            : <RadioButtonUnchecked sx={{ color: grey[400], fontSize: 20, mt: 0.2 }} />
          }
          <Box>
            <Typography variant="body2">{step.title}</Typography>
            {step.observation && (
              <Typography variant="caption" color="text.secondary">{step.observation}</Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  ))
}

function EscalationsView({ data }) {
  return data.map((esc, i) => (
    <Box key={i} sx={{ mt: 1, p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Typography variant="caption" color="text.secondary">
          {esc.user_name} — {esc.created_at ? moment(esc.created_at).locale('pt-br').format('DD-MM-YYYY HH:mm:ss') : ''}
        </Typography>
        <Chip
          label={esc.method}
          size="small"
          color={METHOD_COLOR[esc.method?.toLowerCase()] || 'default'}
          sx={{ fontWeight: 600, fontSize: 11 }}
        />
      </Box>
      <Typography variant="body2" fontWeight={600}>{esc.contato_nome}</Typography>
      {esc.observation && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{esc.observation}</Typography>
      )}
    </Box>
  ))
}

const TITLE_MAP = {
  acks: 'Histórico de Reconhecimento',
  executions: 'Execuções PPI',
  escalations: 'Contatos Acionados',
}

export default function FormDialog({ open, handlerClose, type = 'acks', data = [] }) {
  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={handlerClose}>
      <DialogTitle>{TITLE_MAP[type] || 'Detalhes'}</DialogTitle>
      <DialogContent>
        {data.length === 0 && (
          <Typography color="text.secondary" sx={{ py: 2 }}>Nenhum registro encontrado.</Typography>
        )}
        {type === 'acks' && <AcksView data={data} />}
        {type === 'executions' && <ExecutionsView data={data} />}
        {type === 'escalations' && <EscalationsView data={data} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={handlerClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
}
